<template>
    <div>
        <a-tabs v-model="activedTabKey" :animated="animated">
            <a-tab-pane :key="applicationContentType" tab="申请内容">
                <component
                    :is="applicationContentType"
                    :record="record"
                />
            </a-tab-pane>

            <a-tab-pane :key="approvalContentType" tab="审批内容">
                <component
                    :is="approvalContentType"
                    :record="record"
                />
            </a-tab-pane>
        </a-tabs>

        <custom-portal :to="portalTo">
            <popconfirm-button
                :loading="cancling"
                button-type="text"
                button-text="取消申请"
                title="确认要执行此操作吗？"
                @on-confirm="() => handleCancelApplication()"
            />
        </custom-portal>
    </div>
</template>
<script>
import { Tabs as ATabs, Button as AButton } from 'ant-design-vue'
import PopconfirmButton from '@components/PopconfirmButton'
import CustomPortal from '@components/CustomPortalVue/Portal'

import cancelApplicationService from '@service/approal/fillingApplication/cancelApplicationService'


const APPLICATION_CONTENT_TYPE = 'ApplicationContent'
const APPROVAL_CONTENT_TYPE = 'ApprovalContent'

const DYNAMIC_COMPONENT = {
    [APPLICATION_CONTENT_TYPE]: () => import('./ApplicationContent'),
    [APPROVAL_CONTENT_TYPE]: () => import('./ApprovalContent')
}

export const PORTAL_KEY = 'FillingApplicationModal'

export default {
    name: 'FillingApplicationModalContent',
    components: {
        ATabs,
        AButton,
        CustomPortal,
        PopconfirmButton,
        ...DYNAMIC_COMPONENT,
        ATabPane: ATabs.TabPane
    },
    props: {
        record: {
            type: Object,
            default: () => ({})
        },
        isDetailModal: Boolean
    },
    data() {
        return {
            portalTo: PORTAL_KEY,

            cancling: false,

            animated: Object.freeze({
                inkBar: true,
                tabPane: false
            }),

            activedTabKey: APPLICATION_CONTENT_TYPE,
            approvalContentType: APPROVAL_CONTENT_TYPE,
            applicationContentType: APPLICATION_CONTENT_TYPE
        }
    },
    methods: {
        async handleCancelApplication() {
            try {
                this.cancling = true

                // eslint-disable-next-line
                await cancelApplicationService({ workflowApplyRecordId: this.record.id })

                this.$message.success('取消成功')

                this.$emit('on-after-confirm')
            } catch (e) {
                this.$message.warning(e.message)
                this.$captureException(e)
            } finally {
                this.cancling = false
            }
        }
    }
}
</script>
